<h3-feedback-panel (panelClose)="close()">
  @for (feedback of highlightFeedbacks$ | async; track feedback.feedbackId) {
    <h3-highlight-feedback-item
      [highlightFeedback]="feedback"
    ></h3-highlight-feedback-item>
  }
</h3-feedback-panel>
